export default __webpack_public_path__ + "static/media/mercury2.a7105a56.png";